type Validator = (value?: unknown) => unknown;

export function composeValidators(...validators: Validator[]) {
  return (value: unknown) => validators.reduce((error, validator) => error || validator(value), undefined);
}
